'use strict';
/**
 * A simple directive to display the empty libary notifications. This fetches the homepage activities as a placeholder.
 * This expects a translate-type of either "saved" or "history" to know what wording to put
 */

angular.module('youth').directive('msEmptyLibrary', [function () {
  return {
    templateUrl: 'youth/templates/emptystates/empty-library.html',
    restrict: 'A',
    scope: {
      translateType: '@'
    },
    controller: ['activitySvc', function (activitySvc) {
      var vm = this;
      // we load home activities to fill placeholder
      activitySvc.getHomeActivities().then(function (resp) {
        vm.mockActivities = resp;
      });
    }],
    controllerAs: 'vm',
    bindToController: true
  };
}]);